export const socialUrls = {
  facebookUrl: 'https://www.facebook.com/HousingAnywherecom',
  twitterUrl: 'https://twitter.com/HousingAnywhere',
  linkedinUrl: 'https://linkedin.com/company/housinganywhere',
  youtubeUrl: 'https://www.youtube.com/user/HousingAnywhere',
};
